export default "__VITE_ASSET__oR3VfjU0__"